import { createVanIconComponent } from "./van"

const ShopCollectOutlined = createVanIconComponent("shop-collect-o")
export default ShopCollectOutlined
